<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">As I’ve searched the collections of many fine Montana libraries and archives, I’ve enjoyed the help of many along the way. My thanks to Cindy Shearer, Gallatin Historical Society; Jan Thomson, Gary Goettel and the Great Falls Genealogy Society; Megan Sanford and The History Museum, Great Falls; Alan Archambault, Fort Lewis Museum; Director Tate Jones, the Rocky Mountain Museum of Military History; Director Ray Read, Montana Military Museum; Director Ellen Crane, Butte/Silver Bow County Archives; Administrator Joren Underdahl, Montana Veterans’ Home; and Nancy Watt, Fergus County Library.</p>
<p class="indent">To Kim Briggeman, Aaron Parrott, Kristen Inbody and Ed Kemmick; to Kevin Kooilstra, Western Heritage Center; to Kathryn Kramer, Charles M. Russell Museum; and to Bruce Whittenberg and everyone at the Montana Historical Society. To Jon Arneson, Aaron Flint and Tom Halverson, who opened their airways to history discussions; to the Van Voast family; to Marijke Taffein at St. Mihiel American Cemetery, France; and to Bethany Monroe DeBorde and her splendid newspaper, the <i>River Press</i>.</p>
<p class="indent">And to my colleagues, Henry Armstrong, Dan Van Voast and Dan Nelsen, at the Overholser Historical Research Center. Finally, great thanks to Karin and Ian, Pippi and Astrid.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgment.vue?168f200a